<template>
  <div class="content">
    <div class="pc-browser top-contain">
    <div class="top-contain-bg">
      <div class="menu">

        <div class="menu-content">
          <!--<div class="title">VALSE 2026 武汉</div>-->
          <table>
            <tr>
              <td class="title">VALSE 2026 武汉</td>
              <td><router-link :to="{ name: 'Home' }"><span  class="menu-active">首页</span></router-link></td>
              <td><router-link :to="{ name: 'Committees' }">组委会</router-link></td>
              <td><router-link :to="{ name: 'Program' }">大会程序</router-link></td>
              <td><router-link :to="{ name: 'Speaker' }">特邀报告</router-link></td>
              <td><router-link :to="{ name: 'Tutorial' }">TUTORIAL</router-link></td>
              <td><router-link :to="{ name: 'Workshop' }">WORKSHOP</router-link></td>
              <td><router-link :to="{ name: 'APR' }">APR报告</router-link></td>
              <td><router-link :to="{ name: 'Posters' }">POSTER</router-link></td>
              <td><router-link :to="{ name: 'Register' }">会议注册</router-link></td>
              <td><router-link :to="{ name: 'Hotel' }">交通和酒店</router-link></td>
              <td><router-link :to="{ name: 'Sponsors' }">合作单位</router-link></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="top-content">
        <el-row>
          <el-col :span="12">
            <div class="top-left" style="color: darkmagenta;">
              <div class="left-title">
                <p>VALSE 2026 武汉</p>
                <p>视觉与学习青年学者研讨会</p>
                <!-- <a href='http://valser.org/2022/VALSE_2022_会议通知.pdf' target='_blank' class='news-item'> <span style='color: red;font-weight: 500;'>VALSE 2022 会议通知</span></a> -->
              </div>
              <div class="left_content">
                <table>
                  <tr>
                    <td><span class="top-info">会议时间：</span></td>
                    <td class="content-td top-info">2026年5月8-10日</td>
                  </tr>
                  <tr>
                    <td><span class="top-info">会议地点：</span></td>
                    <td class="content-td top-info">武汉国际会议中心</td>
                  </tr>
                  <tr>
                    <td><span class="top-info">主办单位：</span></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会</span></td>
                  </tr>
                  <!-- <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会</span></td>
                  </tr> -->
                 
                  <tr>
                    <td><span class="top-info">承办单位：</span></td>
                    <td class="content-td"><span class="top-info">华中科技大学</span></td>
                  </tr>
                  <tr>
                    <td><span class="top-info"></span></td>
                    <td class="content-td"><span class="top-info">武汉大学</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国地质大学（武汉）</span></td>
                  </tr>
                   <tr>
                    <td><span class="top-info">协办单位：</span></td>
                    <td class="content-td"><span class="top-info">AutoDL</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会青年工作委员会</span></td>
                  </tr>
                  
                  <!--<tr>
                    <td><span class="top-info">支持单位：</span></td>
                    <td class="content-td"><span class="top-info">重庆市科学技术协会</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市青年科技领军人才协会</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市科学技术局</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市教育委员会</span></td>
                  </tr> -->
                </table>
              </div>
              <!-- <div class="left_info">
                <p>会议时间：<span style="color:red;">2023年6月10-12日</span></p>
              </div>
              <div class="left_info dizhi">
                <p>会议地点：<span style="color:red;">无锡太湖国际博览中心</span></p>
              </div>
              <div class="top-info">主办单位：<span class="danwei">中国人工智能学会</span></div>
              <div class="top-info"><span class="danwei">中国图象图形学学会</span></div> -->
            </div>


          </el-col>
          <el-col :span="12">
            <div class="top-right">
              <div class="right-title">新&nbsp;&nbsp;闻</div>
              <div class="right-content">
                <p v-for="item in news">
                <!--<span class="news-time">{{ item.time }}</span> -->
                  <span v-html="item.title"></span>
              </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="info-list" style="text-align:left; color: red; font-size: 18px; text-indent: 2em; margin-bottom: -48px; padding-top: 8px;"><a href='#/register' class='news-item'>近期VALSE邮箱和公众号以及组委会老师邮箱收到大量参会相关的咨询信息，因时间原因无法一一回复，望各位理解。现就大家关注的几个问题，组委会做出统一说明，点击查看详情。</a></div>
      </div>
      
    </div>

  </div>
    <div class="mobile-browser">
      <div class="mobile-top-contain">
        <div class="mobile-menu-contain">
          <div class="mobile-menu">
            <div class="mobile-menu-grp">
              <span class="web-title" >VALSE 2026 武汉</span>
              <span @click="moreMenuClick" class="more-menu-btn">
                <!--<i class="more-menu-btn-icon el-icon-menu"></i>-->
                <!--<img src="../../static/images/moremenu_btn.png" class="more-menu-btn-icon"/>-->
                <div class="more-menu-btn-icon"></div>
              </span>
            </div>
          </div>
          <transition name="el-zoom-in-top">
          <div class="vertical-menu" v-show="verticalMenuShow">
              <el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect"
                text-color="white" active-text-color="#b3b3b3" background-color="#0053a1">
                <el-menu-item index="Home" :route="{ name: 'Home'}">首页</el-menu-item>
                <el-menu-item index="Committees" :route="{ name: 'Committees'}">组委会</el-menu-item>
                <el-menu-item index="Program" :route="{ name: 'Program'}">大会程序</el-menu-item>
                <el-menu-item index="Speaker" :route="{ name: 'Speaker'}">特邀报告</el-menu-item>
                <el-menu-item index="Tutorial" :route="{ name: 'Tutorial'}">TUTORIAL</el-menu-item>
                <el-menu-item index="Workshop" :route="{ name: 'Workshop'}">WORKSHOP</el-menu-item>
                <el-menu-item index="APR" :route="{ name: 'APR'}">APR报告</el-menu-item>
                <el-menu-item index="Posters" :route="{ name: 'Posters'}">POSTER</el-menu-item>
                
                <el-menu-item index="Register" :route="{ name: 'Register'}">会议注册</el-menu-item>
                <el-menu-item index="Hotel" :route="{ name: 'Hotel'}">交通和酒店</el-menu-item>
                <el-menu-item index="Sponsors" :route="{ name: 'Sponsors'}">合作单位</el-menu-item>
              </el-menu>
            </div>
          </transition>
        </div>
        <div class="mobile-top-item">
          <div class="top-left">
            <div class="left-title">
              <p>VALSE 2026 武汉</p>
              <p>视觉与学习青年学者研讨会</p>
              <!-- <a href='http://valser.org/2022/VALSE_2022_会议通知.pdf' target='_blank' class='news-item'> <span style='color: red;font-weight: 500;'>VALSE 2022 会议通知</span></a> -->
            </div>
            <div class="left_content">
                <table>
                  <tr>
                    <td><span class="top-info">会议时间：</span></td>
                    <td class="content-td top-info">2026年5月8-10日</td>
                  </tr>
                  <tr>
                    <td><span class="top-info">会议地点：</span></td>
                    <td class="content-td top-info">武汉国际会议中心</td>
                  </tr>
                  <tr>
                    <td><span class="top-info">主办单位：</span></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会</span></td>
                  </tr>
                  <!-- <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会</span></td>
                  </tr> -->
                
                  <tr>
                    <td><span class="top-info">承办单位：</span></td>
                    <td class="content-td"><span class="top-info">华中科技大学</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">武汉大学</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国地质大学（武汉）</span></td>
                  </tr>
                  <tr>
                    <td><span class="top-info">协办单位：</span></td>
                    <td class="content-td"><span class="top-info">AutoDL</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">中国图象图形学学会青年工作委员会</span></td>
                  </tr>
                  <!-- <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">AutoDL</span></td>
                  </tr> -->
                  <!--<tr>
                    <td><span class="top-info">支持单位：</span></td>
                    <td class="content-td"><span class="top-info">重庆市科学技术协会</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市青年科技领军人才协会</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市科学技术局</span></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="content-td"><span class="top-info">重庆市教育委员会</span></td>
                  </tr> -->
                </table>
              </div>
            <!-- <div class="left_info">
              <p>会议时间：<p/>
              <p style="color:red;">2023年6月10-12日</p>
              
            </div>
            <div class="left_info">
              <p>会议地点：<p/>
              <p style="color:red;">无锡太湖国际博览中心</p> -->
            <!-- </div> -->
          </div>
          <div class="info-list" style="text-align:left; color: red; font-size: 18px; text-indent: 2em; padding-left: 6px;"><a href='#/register' class='news-item'>近期VALSE邮箱和公众号以及组委会老师邮箱收到大量参会相关的咨询信息，因时间原因无法一一回复，望各位理解。现就大家关注的几个问题，组委会做出统一说明，点击查看详情。</a></div>

          <div class="top-right mobile-news-list">
            <div class="right-title">新&nbsp;&nbsp;闻</div>
            <div class="right-content">
              <p v-for="item in news">
                <!--<span class="news-time">{{ item.time }}</span> -->
                <span v-html="item.title"></span>
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pc-browser1">
    <div class=" middle-content content-jianjie">
      <div class="content-title">
        <p><strong>VALSE 2026 武汉</strong></p>
      </div>
      <div class="content-info-contain">
        <div class="content-info">
          <p>VALSE年度研讨会为计算机视觉、图像处理、模式识别、机器学习、具身智能、机器人等研究领域内的中国青年学者提供一个深层次学术交流的舞台。在这个舞台上，我们恪守并倡导理性批判、勇于探索、实证、创新等科学精神；在这个舞台上，我们倡导自由平等原则下、理性而纯学术的百家争鸣和思想交锋；这个舞台上，我们期望欣赏到国内青年学者越来越优美的学术华尔兹（VALSE）。通过这个舞台，我们期望促进国内青年学者的思想交流和学术合作，从而在相关领域做出重量级学术贡献，提升中国学者在国际学术舞台上的学术影响力。</p>
          <!-- <p>VALSE年度研讨会的主要目的是为计算机视觉、图像处理、模式识别与机器学习研究领域内的中国青年学者提供一个深层次学术交流的舞台。在这个舞台上，我们恪守并倡导理性批判、勇于探索、实证、创新等科学精神；在这个舞台上，我们倡导自由平等原则下、理性而纯学术的百家争鸣和思想交锋；这个舞台上，我们期望欣赏到国内青年学者越来越优美的学术华尔兹（VALSE）。通过这个舞台，我们期望促进国内青年学者的思想交流和学术合作，从而在相关领域做出重量级学术贡献，提升中国学者在国际学术舞台上的学术影响力。</p> -->
          <p>截至目前，VALSE已成功举办15届，分别为 VALSE 2011（杭州），VALSE 2012（西安），VALSE 2013（南京），VALSE 2014（青岛），VALSE 2015（成都），VALSE 2016（武汉），VALSE 2017（厦门），VALSE 2018（大连），VALSE 2019（合肥），VALSE 2020（线上），VALSE 2021（杭州），VALSE 2022（天津），VALSE 2023（无锡），VALSE 2024（重庆），VALSE 2025（珠海）。VALSE 2026 将在武汉举行，由华中科技大学、武汉大学和中国地质大学（武汉）承办。</p>
          <div class="zhubanfang-logo" v-show="false">
            <div class="zhubanfang-item">
              <table>
                <tr>
                  <td><img src="static/images/jiangnandaxue.png" /></td>
                  
                </tr>
                <tr>
                  <td>江南大学</td>
                </tr>
              </table>
            </div>
            <div class="zhubanfang-item">
              <table>
                <tr>
                  <td><img src="static/images/xinwuqu.png" /></td>
                  
                </tr>
                <tr>
                  <td>无锡国家高新技术<br/>产业开发区管理委员会</td>
                </tr>
              </table>
            </div>
            
          </div>
        </div>
      </div>


    </div>
    <div class="middle-content content-zanzhushang">
      <div class="content-title">
        <p><strong>VALSE 2025 合作单位</strong></p>
      </div>
      <div class="content-info-contain">
        <div class="content-info">
        <p>
          VALSE 2026 诚招合作单位：  2011年以来，VALSE 已分别于杭州、西安、南京、青岛、成都、武汉、厦门、大连、合肥、杭州、线上、天津、无锡、重庆、珠海成功举办15届，得到了多家知名企业的鼎力合作。2026年，VALSE将在武汉举办，为了办好 VALSE 2026 这一盛会，我们诚挚邀请相关企业踊跃合作！
        <br/>
          联系人：
        <br/>
        
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 白翔 (xbai@hust.edu.cn)；山世光 (sgshan@ict.ac.cn)；程明明 (cmm@nankai.edu.cn)；姬艳丽 (yanliji@uestc.edu.cn)
        </p>

<!-- <template>
  <el-carousel :interval="4000" type="card" height="200px">
    <el-carousel-item v-for="activity in sponsorsact">
      <div class="sponsor-activity-content"><img :src=activity></div>
    </el-carousel-item>
  </el-carousel>
</template> -->




        <div class="zanzhushang-contain">
          <table>
            <tr class="zanzhushang-item">
              <td width="100px" align="center">
                <div class="zanzhushang-title">
                  <img src="static/images/zhuanshi.jpg"/><br/>
                  <span>铂金合作</span>
                </div>
              </td>
              <td>
                <div class="zanshushang-list">
                  <a :href="item.href" target="_blank" class="sponsors-item" v-for="item in sponsors.bojin">
                    <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">
                      <!--<img :src="item.icon"/>-->
                    </div>
                  </a>
                </div>
              </td>
            </tr>
            <tr class="zanzhushang-item">
              <td width="100px" align="center">
                <div  class="zanzhushang-title">
                  <img src="static/images/zhuanshi.jpg"/>
                  <div>金牌合作</div>
                </div>

              </td>
              <td>
                <div class="zanshushang-list">
                  <a :href="item.href" target="_blank"  class="sponsors-item" v-for="item in sponsors.jinpai">
                    <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">
                      <!--<img :src="item.icon"/>-->
                    </div>
                  </a>
                </div>
              </td>
            </tr>
            <tr class="zanzhushang-item zanshushang-last-item">
              <td width="100px" align="center">
                <div  class="zanzhushang-title">
                  <img src="static/images/zhuanshi.jpg"/>
                  <div>银牌合作</div>
                </div>

              </td>
              <td>
                <div class="zanshushang-list">
                  <a :href="item.href" target="_blank"  class="sponsors-item" v-for="item in sponsors.yinpai">
                    <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">
                      <!--<img :src="item.icon"/>-->
                    </div>
                  </a>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="item-content" id='sponsor-activity'>
            <div class="item-text-content sponsor-activity-div">
              <div class="zanshushang-list">
                <a :href="item.actref" target="_blank"  class="sponsors-item sponsor-activity-content" v-for="item in sponsors.bojin" v-if="item.hasOwnProperty('time') && item.time!=''">
                  <!-- <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div> -->
                  <div class="sponsor-name">{{item.acttitle}}</div>
                  
                  <div class="sponsor-activity">
                    <div class="sponsor-activity-tile">时间：<span class='activity-content'>{{item.time}}</span></div>
                    <div class="sponsor-activity-tile">地点：{{item.addr}}</div>
                    <div class="sponsor-activity-tile" >报名：<span class='activity-content'>{{item.actbaoming}}</span></div>
                    <!-- <div class="sponsor-activity-tile" style="color:#F56C6C; text-align:right;"><a :href="item.actref" target="_blank" >点击报名</a></div> -->
                    <div class="sponsor-activity-tile">简介：{{item.content}}</div>
                    <!-- <img :src="item.actimage"> -->
                  </div>
                  
                </a>
                <a :href="item.actref" target="_blank"  class="sponsors-item sponsor-activity-content" v-for="item in sponsors.jinpai" v-if="item.hasOwnProperty('time') && item.time!=''">
                  <!-- <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div> -->
                  <div class="sponsor-name">{{item.acttitle}}</div>
                  
                  <div class="sponsor-activity">
                    <div class="sponsor-activity-tile">时间：<span class='activity-content'>{{item.time}}</span></div>
                    <div class="sponsor-activity-tile">地点：{{item.addr}}</div>
                    <div class="sponsor-activity-tile" >报名：<span class='activity-content'>{{item.actbaoming}}</span></div>
                    <!-- <div class="sponsor-activity-tile" style="color:#F56C6C; text-align:right;"><a :href="item.actref" target="_blank" >点击报名</a></div> -->
                    <div class="sponsor-activity-tile">简介：{{item.content}}</div>
                    <!-- <img :src="item.actimage"> -->
                  </div>
                </a>
                <a :href="item.actref" target="_blank"  class="sponsors-item sponsor-activity-content" v-for="item in sponsors.yinpai" v-if="item.hasOwnProperty('time') && item.time!=''">
                  <!-- <div class="sponsor-logo" :style="{'background-image':'url('+item.icon+')'}">

                  </div> -->
                  <div class="sponsor-name">{{item.acttitle}}</div>
                  
                  <div class="sponsor-activity">
                    <div class="sponsor-activity-tile">时间：<span class='activity-content'>{{item.time}}</span></div>
                    <div class="sponsor-activity-tile">地点：{{item.addr}}</div>
                    <div class="sponsor-activity-tile" >报名：<span class='activity-content'>{{item.actbaoming}}</span></div>
                    <!-- <div class="sponsor-activity-tile" style="color:#F56C6C; text-align:right;"><a :href="item.actref" target="_blank" >点击报名</a></div> -->
                    <div class="sponsor-activity-tile">简介：{{item.content}}</div>
                    <!-- <img :src="item.actimage"> -->
                  </div>
                </a>
              </div>
            </div>
          </div>
      </div>
      </div>


    </div>
    <div class="content-contactus">
      <div class="pc-browser contacus-content">
        <el-row>
          <el-col :span="8">
            <div class="valse-past">
              <div class="contactus-title ">
                <p><strong>VALSE PAST</strong></p>
              </div>
              <div class="contactus-info last-page">
                <ul>
                  <li>
                    <a href="http://valser.org/2025/" target="__blank">VALSE 2025 珠海</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2024/" target="__blank">VALSE 2024 重庆</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2023/" target="__blank">VALSE 2023 无锡</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2022/" target="__blank">VALSE 2022 天津</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2021/" target="__blank">VALSE 2021 杭州</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2020/" target="__blank">VALSE 2020 线上</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2019/" target="__blank">VALSE 2019 合肥</a>
                  </li>
                  <li>
                    <a href="http://ice.dlut.edu.cn/valse2018/index.html" target="__blank">VALSE 2018 大连</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2017/" target="__blank">VALSE 2017 厦门</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2016/" target="__blank">VALSE 2016 武汉</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2015/" target="__blank">VALSE 2015 成都</a>
                  </li>
                  <li>
                    <a href="http://valser.org/2014/" target="__blank">VALSE 2014 青岛</a>
                  </li>
                  <li>
                    <a href="http://cse.seu.edu.cn/valse13/" target="__blank">VALSE 2013 南京</a>
                  </li>
                  <li>
                    <a href="http://optimal.opt.ac.cn/VALSE2012/" target="__blank">VALSE 2012 西安</a>
                  </li>
                  <li>
                    <a href="http://www.cs.zju.edu.cn/~gpan/valse2011/" target="__blank">VALSE 2011 杭州</a>
                  </li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="lianxiwomen">
              <div class="contactus-title">
                <p><strong>联系我们</strong></p>
              </div>
              <div class="contactus-info">
            <p>VALSE邮箱<br/>valse_official@163.com</p>
            <!-- <p>吴小俊<br/>wu_xiaojun@jiangnan.edu.cn</p>
            <p>山世光<br/>sgshan@ict.ac.cn</p> -->
              </div>
            </div>

          </el-col>
          <el-col :span="8">
            <div class="valsezaixian">
              <div class="contactus-title">
                <p><strong>VALSE 在线</strong></p>
              </div>
              <div class="contactus-info">
                <ul>
                  <li>
                    网址：valser.org
                  </li>
                  <li>
                    微信公共账号：VALSE
                  </li>
                </ul>
                <img src="static/images/valse_wechat.jpg"/>
              </div>
            </div>

          </el-col>
        </el-row>
      </div>
      <div class="mobile-browser contacus-content">
        <div class="valse-past">
          <div class="contactus-title ">
            <p><strong>VALSE PAST</strong></p>
          </div>
          <div class="contactus-info last-page">
            <ul>
              <li>
                <a href="https://valser.org/2023/" target="__blank">VALSE 2023 无锡</a>
              </li>
              <li>
                <a href="https://valser.org/2022/" target="__blank">VALSE 2022 天津</a>
              </li>
              <li>
                    <a href="https://valser.org/2021/" target="__blank">VALSE 2021 杭州</a>
                  </li>
              <li>
                <a href="https://valser.org/2020/" target="__blank">VALSE 2020 线上</a>
              </li>
              <li>
                <a href="https://valser.org/2019/" target="__blank">VALSE 2019 合肥</a>
              </li>
              <li>
                <a href="http://ice.dlut.edu.cn/valse2018/index.html" target="__blank">VALSE 2018 大连</a>
              </li>
              <li>
                <a href="https://valser.org/2017/" target="__blank">VALSE 2017 厦门</a>
              </li>
              <li>
                <a href="https://valser.org/2016/" target="__blank">VALSE 2016 武汉</a>
              </li>
              <li>
                <a href="https://valser.org/2015/" target="__blank">VALSE 2015 成都</a>
              </li>
              <li>
                <a href="https://valser.org/2014/" target="__blank">VALSE 2014 青岛</a>
              </li>
              <li>
                <a href="http://cse.seu.edu.cn/valse13/" target="__blank">VALSE 2013 南京</a>
              </li>
              <li>
                <a href="http://optimal.opt.ac.cn/VALSE2012/" target="__blank">VALSE 2012 西安</a>
              </li>
              <li>
                <a href="http://www.cs.zju.edu.cn/~gpan/valse2011/" target="__blank">VALSE 2011 杭州</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="lianxiwomen">
          <div class="contactus-title">
            <p><strong>联系我们</strong></p>
          </div>
          <div class="contactus-info">
            <p>VALSE邮箱<br/>valse_official@163.com</p>
          </div>
        </div>
        <div class="valsezaixian">
                <div class="contactus-title">
                  <p><strong>VALSE 在线</strong></p>
                </div>
                <div class="contactus-info">
                  <ul>
                    <li>
                      网址：valser.org
                    </li>
                    <li>
                      微信公共账号：VALSE
                    </li>
                  </ul>
                  <img src="static/images/valse_wechat.jpg"/>
                </div>
              </div>
      </div>

    </div>
    <div class="footer-contain">
      <p>© VALSE 2026 All rights reserved</p>
    </div>
  </div>
</div>

</template>

<script>

    export default {
      name: "Home",
      created:function(){
        this.activeIndex = this.$route.name;
      },
      data () {
        return {
          sponsors:this.$dicts.sponsors,
          sponsorsBojin:this.$dicts.sponsors.bojin,
          sponsorsJinpai:this.$dicts.sponsors.jinpai,
          sponsorsYinpai:this.$dicts.sponsors.yinpai,
          activeIndex: 'Home',
          verticalMenuShow: false,
          screenWidth: document.body.clientWidth,
          // topBgStyle:"background-size:30% auto,30% auto;-moz-background-size:30% auto,30% auto;",
          news:[],
          // $el:"el-icon-menu"
          sponsorsact:[],
        }
      },
      methods: {
        handleSelect (index, indexpath) {
          this.activeIndex = index;
          this.$router.push({ name: index})
        },
        moreMenuClick(){
            this.verticalMenuShow = (this.verticalMenuShow)?false:true;
        },
        clickNews(pathName){
          console.log(pathName);
        }
      },
      mounted(){
        var v = this;
        var tmp = {
          time:"2023-03-27",
          title: " <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>VALSE 2026 武汉，欢迎您！</span>",
        };
        v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a href='#/register' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击查看现场注册的相关说明。</span></a>",
        // };
        // v.news.push(tmp);
        var tmp = {
          time:"",
          title: "<a target='_blank' href='./static/VALSE2026_HYTZ.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2026会议通知。</span></a>",
        };
        v.news.push(tmp);
        var tmp = {
          time:"",
          title: "<a target='_blank' href='./static/VALSE2025_HYTZ_EN.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2025会议通知（英文）。</span></a>",
        };
        // v.news.push(tmp);
        var tmp = {
          time:"",
          title: "<a target='_blank' href='./static/VALSE2025_HYSC.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2025会议手册。</span></a>",
        };
        // v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a target='_blank' href='./static/HYJDLB20210902.xlsx' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载悦来国际会议中心周边酒店列表。</span></a>",
        // };
        // v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a target='_blank' href='./static/VALSE2022_YQH.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2022邀请函。</span></a>",
        // };
        // v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a target='_blank' href='./static/VALSE2022_Poster_YQH.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2022 Poster邀请函。</span></a>",
        // };
        // v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a target='_blank' href='./static/VALSE2022_HYSC.pdf' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击下载VALSE2022会议手册。</span></a>",
        // };
        // v.news.push(tmp);
        // var tmp = {
        //   time:"",
        //   title: "<a  href='#sponsor-activity' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击查看赞助商活动。</span></a>",
        // };
        // v.news.push(tmp);
        var tmp = {
          title: "<a href='#/poster' class='news-item'> <span style='color: red;font-weight: 500;'><i class='iconfont icon-dianzan'></i>点击查看VALSE 2025 Poster征集通知。</span></a>",
        };
        // v.news.push(tmp);
        
        
        var tmpArr = this.sponsorsBojin;
        for(var i=0; i <= tmpArr.length-1; i++){
          var val = tmpArr[i];
          var tmp = {
            time:"2022-01-01",
            title: "<span style='color: red;font-weight: 500;'>"+val.name+"</span> 成为VALSE 2025 铂金合作单位",
          };
          if(val.isnew == false){
            v.news.push(tmp);
          }

        };
        tmpArr = this.sponsorsJinpai;
        // for(var i = tmpArr.length-1; i >=0; i--){
        for(var i=0; i <= tmpArr.length-1; i++){
          var val = tmpArr[i];
          var tmp = {
            time:"2022-01-01",
            title: "<span style='color: red;font-weight: 500;'>"+val.name+"</span> 成为VALSE 2025 金牌合作单位",
          };
          if(val.isnew == false){
            v.news.push(tmp);
          }
        };
        tmpArr = this.sponsorsYinpai;
        // for(var i = tmpArr.length-1; i >=0; i--){
        for(var i=0; i <= tmpArr.length-1; i++){
          var val = tmpArr[i];
          var tmp = {
            time:"2022-01-01",
            title: "<span style='color: red;font-weight: 500;'>"+val.name+"</span> 成为VALSE 2025 银牌合作单位",
          };
          if(val.isnew == false){
            v.news.push(tmp);
          }
        };
        // for(var i = this.sponsorsBojin.length-1; i >=0; i--){
        //   var val = this.sponsorsBojin[i];
        //   if (val.hasOwnProperty('time') && val.time!=''){
        //     this.sponsorsact.push(val.actimage)
        //   }
          
        // };


      }
    }
</script>

<style scoped>
.top-info{
  /* padding: 0 8px; */
  text-align: left;
  font-weight: bolder;
  font-size: 18px;
  white-space: pre-wrap;
  word-wrap:break-word;
  /* text-indent: 2em; */
}
  .content{
    min-width: 900px;
    background-image: url("../../static/images/app_bg_1.jpg");
    background-repeat: repeat;
  }
  .top-contain{
    /* background-image: url("../../static/images/home_banner.jpg"); */
    /* background-image: url("../../static/images/home_banner_chongqing.jpg"); */
    /* background-image: url("../../static/images/home_banner_zhuhai_3.jpg"); */
    background-image: url("../../static/images/wuhan_home_banner.jpg");
    background-repeat: no-repeat;
    /*background-size: contain;*/
    /*height: 445px;*/
    /*width: 100%;*/
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }
  .top-contain-bg{
    /*background-image: url("../static/images/banner_1_1.jpg");*/
    /*background-repeat: no-repeat;*/
    /*background-size: cover;*/
    /*height: 400px;*/
    /*width: 100%;*/
  }
    .top-contain .menu{
    width: 65%;
    /*min-width: 1010px;*/
    margin: 0 auto;
    padding-top: 50px;
  }

  .top-contain .menu .menu-content{

    /*width: 80%;*/
    /*height: 65px;*/
    background-color: #F2F6FC;
    /*background-image: url("../../static/images/menu_title_bg.png");*/
    background-repeat: no-repeat;
    /*height: 100%;*/
    margin: 0 8px;
    color: black;
    background-size: contain;
    /*padding-left: 230px;*/
    padding-right: 8px;
    /*padding: 4px 0;*/
    /*height: 60px;*/
  }
  .top-contain .menu .menu-content .title{
    color: #0053a1;
    font-size: 24px;
    font-weight: bolder;
    padding: 0 0 10px 0;
    width: 220px;
  }
  /*.top-contain .menu .menu-content table{*/
    /*float: right;*/
  /*}*/

  .menu-content .menu-title-bg{
    float: left;

  }
  .menu-content .el-menu.el-menu--horizontal {
    border: none;
  }
  .menu-content .el-menu--horizontal>.el-menu-item.is-active {
    color: #0053a1;
    font-weight: bolder;
    border: none;
  }
  .menu-content .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    color: #f27d00 !important;
  }
  .menu-content .el-menu-item{
    padding: 0 8px;
  }
  .menu-content table{
    width: 100%;
  }
  .menu-content table td{
    padding: 16px 0;
    font-size: 14px;
     white-space:nowrap;
    vertical-align: bottom;
  }
  .menu-content table td a:hover{
    cursor: pointer;
    color: #f27d00;
  }
  .menu-content img{
    height: 65px;
    margin-top: -10px;
  }
  .menu-content ul{
    list-style: none;
    text-align: left;

    /*padding-top: 24px;*/
    font-size: 13px;
  }
  
  .menu-content ul li{
    display: inline;
    padding: 8px;
  }
  .menu-content ul li:hover{
    color: #f27d00;
    cursor: pointer;
  }
  .menu-content a{
    color: black;
    padding: 0;
  }
  .menu-active{
    color: #0053a1;
    font-weight: bolder;
  }
 .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .sponsor-activity-div{
    padding: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .sponsor-activity-content img{
    height: 220px;
  }
  .sponsor-activity-content{
    width: 300px;
    height: 300px;
    overflow-y: hidden;
  }
  .sponsor-activity{
    text-align: left;
    text-indent:0;
    font-size: 14px;
    line-height:1.5em;
    color: #606266;
  }
  .activity-content{
    color: #F56C6C;
  }
  .sponsor-name{
    text-align: center;
    text-indent: 0;
    font-weight: 700;
  }
  @media screen and (min-width: 1500px) {
    .menu-content table{
      width: 95%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 1500px) {
    .top-contain .menu{
      width: 80%;
      min-width: 1000px;
      margin: 0 auto;
      padding-top: 50px;

    }

  }

 @media screen and (max-width: 1000px) {
    .top-contain .menu{
      width: 90%;
      min-width: 900px;
      margin: 0 auto;
      padding-top: 50px;

    }

  }
  .zhubanfang-logo{
    text-align: center;
    display: flex;
    font-weight: bolder;
    justify-content: center;
  }
  .zhubanfang-logo img{
    height: 120px;
    margin: 0 16px;
  }
  .top-content{
    width: 60%;
    margin: 0 auto;
    color: #0053a1;
    /* color: #fff; */
    margin-top: 60px;
    padding-bottom: 65px;
  }
  .top-left{
    text-align: center;
    border-radius: 10px;
    /* background-color: #F2F6FC; */
    opacity: 0.9;
    margin-right: 8px;
    padding: 8px 0;
    /*padding-right: 21px;*/
    /* padding-bottom:50px; */
  }
  .top-left .left-title p{
    font-size: 26px;
    font-weight: bolder;
    margin: 4px;
  }
  .left_info{
    margin-top: 30px;
    font-weight: bolder;
    font-size: 28px;
  }
  .left_content{
    width: 100%;
    margin-top: 8px;
  }
  .left_content table{
    width: 440px;
    margin: 0 auto;
    font-size: 20px;
    white-space: pre-wrap;
    word-wrap:break-word;
  }
  .left_content .content-td{
    text-align: left;
    
  }
  .dizhi{
    margin-top: 16px;
  }
  .top-left p{
    font-size: 20px;
    /*font-weight: bold;*/
    padding: 2px 0;
    margin: 4px;
  }
  .top-right{
    /*width: 360px;*/
    /*width: 90%;*/
    /*border: 1px solid #0053a1;*/
    /*margin-top: 18px;*/
    /* height: 320px;
    border-radius: 10px;
    background-color: #F2F6FC;
    opacity: 0.9;
    margin-left: 8px; */
    border: 1px solid #0053a1;
    /* border: 1px solid #FFF; */
    margin-top: 18px;
    height: 440px;

  }
  .top-right .right-title{
    /*background-color: #0053a1;*/
    /* color: #0053a1;
    font-size: 18px;
    font-weight: bolder;
    width: 90px;
    margin: 0 auto;
    padding: 4px 0;
    border-radius:12px; */
    background-color: #0053a1;
    color: #fff;
    font-size: 18px;
    font-weight: bolder;
    width: 90px;
    margin: 0 auto;
    padding: 4px 0;
    margin-top: -18px;
    border-radius: 12px;
  }
  .top-right .right-content{
    text-align: left;
    padding: 4px 8px;
    margin-top: 4px;
    height: 410px;
    overflow-y: auto;
  }
  .top-right .right-content p{
    margin: 0;
    font-size: 14px;
    padding: 8px 8px 4px 8px;
    border-bottom: 1px dashed #106deb;
  }
  .top-right .right-content p:hover{
    cursor: pointer;
    color: #f27d00;
  }
  .top-content  .right-content a{
    color: #0053a1;
  }
  .top-right .right-content a:hover{
    cursor: pointer;
    color: #f27d00;
  }

  .middle-content{
    /*background-image: url("../../static/images/jianjie_bg_1.jpg");*/
    /*background-repeat: no-repeat;*/
    /*background-size:100% 100%;*/
    /*-moz-background-size:100% 100%;*/
    /*margin-top: -42px;*/
    /*background-color: rgba(240,240,240,0.7);*/
    padding-bottom: 24px;
    /*margin-top: -20px;*/

  }
  .middle-content .content-title{
    background-image: url("../../static/images/content_title_bg_1.png");
    width: 255px;
    height: 96px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: bottom;
  }
  .middle-content .content-title p{
    color: #0053a1;
    font-size: 20px;
    padding-bottom: 18px;
    font-weight: bolder;
    padding-top: 42px;
    font-family: "Microsoft YaHei";
  }
  .middle-content .content-info{
    width: 60%;
    margin: 0 auto;
    text-align: justify;
    font-size: 18px;
    padding-top: 8px;
  }
  .middle-content .content-info p{
    line-height: 2em;
    padding-top: 8px;
    text-indent: 2em;
  }
  .content-jianjie{
    background-image: url("../../static/images/jianjie_bg_null.png");
    background-repeat: repeat;
    /*background-size:100% 100%;*/
    /*-moz-background-size:100% 100%;*/
    /*padding-bottom: 60px;*/
    /*background-repeat: no-repeat;*/
    margin-top: -23px;
  }
  .content-jianjie .content-info-contain{
    /*background-image: url("../../static/images/jieshao_left_bg.png"),url("../../static/images/jieshao_right_bg.png");*/
    background-repeat: no-repeat,no-repeat;
    background-position: left bottom,right bottom;
    background-size: auto 80%,auto 80%;
    /*background-size: 25%,20%;*/
    /*padding-bottom: 2%;*/
  }
  .content-zanzhushang{
    /*background-image: url("../../static/images/zanzhushang_bg.png");*/
    /*background-repeat: no-repeat;*/
    /*background-size:100% 100%;*/
    /*-moz-background-size:100% 100%;*/
    /*margin-top: -58px;*/
    background-color: white;
    border-top: 1px solid #f4f4f4;
    box-shadow: 0 0 10px #b1afb0;
  }
  .content-zanzhushang .content-info-contain{
    /*background-image: url("../../static/images/zanzhushang_bg_left_bottom.png"),url("../../static/images/zanzhushang_bg_right_bottom.png");*/
    /*background-position: left bottom,right bottom;*/
    /*background-size: auto 80%, auto 70%;*/
    /*background-image: url("../../static/images/zanzhushang_bg_right_bottom.png");*/
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: auto 70%;
    padding-bottom: 2%;
  }
  .content-contactus{
    /*background-image: url("../../static/images/lianxiwomen_left_bottom.png"),*/
                      /*url("../../static/images/lianxiwomen_right_top.png"),*/
                      /*url("../../static/images/jieshao_left_bg.png");*/
    background-repeat: no-repeat;
    background-position: left bottom,right top,right bottom;
    background-size: auto 30%,auto 20%,auto 80%;
    margin-top: 0px;
    border-bottom: 2px solid #aaaaaa;
  }
  .zanzhushang-contain{
    /*height: 600px;*/
  }
  .zanzhushang-contain table{
    width: 100%;
  }
  .zanzhushang-contain table tr td{
    border-top: 1px dashed #106deb;
    /*height: 160px;*/
  }
  .zanshushang-last-item td{
    border-bottom: 1px dashed #106deb;

  }
  .zanzhushang-item .zanzhushang-title{
    border-right: 1px dashed #106deb;
    padding: 28px 0;
    font-size: 16px;
    color: #106deb;
  }

   .zanshushang-list{
    display: flex;
    flex-wrap:wrap;
    justify-content:flex-start;
  }
  .zanshushang-list .sponsors-item{
    padding: 4px 8px;
    margin: 2px;
    background-color: #f3f3f3;

  }
  .zanshushang-list .sponsors-item:hover{
    cursor: pointer;
    background-color: #DCDFE6;
    color: #f27d00;
  }
  .zanshushang-list .sponsors-item .sponsor-logo img{
    /*width: 100%;*/
    height: 100px;
    /*max-width: 100%;*/
  }
  .zanshushang-list .sponsors-item .sponsor-logo{
    background-repeat: no-repeat;
    /*background-image: url("../../static/images/sponsors/huaweijishu.png");*/
    background-size: contain;
    background-position: center;
    height: 70px;
    width: 120px;
  }

  .contacus-content{
    width: 80%;
    margin: 0 auto;
    overflow: hidden;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .contactus-title{
    background-image: url("../../static/images/content_title_bg_1.png");
    width: 152px;
    height: 60px;
    margin: 0 auto;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: bottom;
  }
  .contactus-title p{
    color: #0053a1;
    font-size: 20px;
    padding-bottom: 18px;
    font-weight: bolder;
    padding-top: 18px;
    font-family: "Microsoft YaHei";
  }
  .contactus-info{
    text-align: left;
    font-size: 16px;
    /*width: 180px;*/
    margin: 28px 0;
  }
  .valse-past .last-page ul{
    margin-left: -5px;
  }
  .contactus-info ul, menu, dir{
    /*width: 160px;*/
    margin: 0 auto;
  }
  .contactus-info li{
    padding: 4px 0;

  }
  .contactus-info a{
    color: #2c3e50;
  }
  .contactus-info a:hover{

  }
  .valse-past{
    width: 180px;
    margin: 0 auto;
  }
  .lianxiwomen{
    /*width: 320px;*/
    margin: 0 auto;
  }

  .lianxiwomen ul{
    margin-left: -7px;
  }
  .valsezaixian{
    width: 200px;
    margin: 0 auto;
  }
  .valsezaixian .contactus-info ul{
    /*margin-left: -44px;*/
  }
  .valsezaixian img{
    width: 60%;
    margin-top: 8px;

    margin-left: 40px;
  }
  .footer-contain{
    /*background-image: url("../../static/images/footer_bg.png");*/
    background-repeat: no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
    margin-top: 8px;
  }
  .footer-contain p{
    /*padding: 84px;*/
    padding: 16px;
    text-align: center;
    margin: 0;
    font-size: 15px;
  }
  .contactus-info a:hover,.contactus-info li:hover{
    color: #f27d00;
    cursor: pointer;
    font-size: 16px;
  }
  .pc-browser{
    display: inherit;
  }
  .mobile-browser{
    display: none;
  }
  .lianxiwomen p{
    text-align: center;
  }
  .lianxiwomen .contactus-info p:hover,.lianxiwomen .contactus-info p:hover{
    color: #f27d00;
    cursor: pointer;
    font-size: 16px;
  }



  @media screen and (max-width: 1000px){
    .content{
      min-width: 200px;
      width: 100%;
    }
    .pc-browser{
      display: none;
    }
    .mobile-browser{
      display: inherit;

    }
    .mobile-top-contain{
      color: #0053a1;
      /* color: #FFF; */
      padding-bottom: 24px;
      /* background-image: url("../../static/images/home_mobile_banner.jpg"); */
      background-image: url("../../static/images/home_banner_wuhan_1.jpg");
      background-repeat: no-repeat;
      background-size:100% 100%;
      -moz-background-size:100% 100%;
      background-color: #fafafa;
      box-shadow: 0px 3px 2px #b4b4b4;
    }

    .top-left{
      /*padding-top: 80px;*/
      margin: 20px;
      margin-bottom: 8px;
      padding-bottom: 8px;
      /*background-color: white;*/
      /*background-image: url("../../static/images/home_mobile_left_banner.png"),url("../../static/images/home_mobile_right_banner.png");*/
      /*background-repeat: no-repeat;*/
      /*background-size:30% auto,30% auto;*/
      /*-moz-background-size:30% auto,30% auto;*/
      /*background-position:left 60px,right 60px;*/
      /*background-image: url("../../static/images/home_mobile_banner.png");*/
      /*background-repeat: no-repeat;*/
      /*background-size:100% auto;*/
      /*-moz-background-size:100% auto;*/
      /*background-position:center 60px;*/
    }
    .top-left .left-title p{
      font-size: 28px;
      font-weight: bolder;
    }
    .left_info{
      margin-top: 28px;
      font-weight: bolder;
    }
    .mobile-menu-contain{
      width: 100%;
      height: 60px;
    }
    .mobile-menu{
      background-color: #f6faff;
      padding: 0px;
      position: fixed;
      width: 100%;
      border-bottom: 1px solid #86add2;
      border-top: 1px solid #EBEEF5;
      z-index: 1000;
    }
    .mobile-menu-grp{
      /*background-image: url("../../static/images/menu_song.png");*/
      background-repeat: no-repeat;
      background-size: contain;
      font-size: 24px;
      padding: 12px 0;
      color: #0053a1;
    }
    .more-menu-btn{
      position: absolute;
      font-size: 38px;
      /*right: 12px;*/
      z-index: 8000;
      height: 100%;
      top: 0;
      right: 0;
      width: 40px;
      padding-right: 12px;
    }
    .more-menu-btn .more-menu-btn-icon{
      background-image: url("../../static/images/moremenu_btn.png");
      background-repeat: no-repeat;
      background-size: 30px 20px;
      background-position: center;
      width: 100%;
      height: 100%;
    }
    .web-title{
      text-align: center;
      font-weight: bolder;

    }
    .vertical-menu{
      border-top: 1px solid #0053a1;
      top: 59px;
      bottom: 0;
      position: fixed;
      /*width: 120px;*/
      right: 0;
      overflow-y: auto;
      z-index: 1000;
    }
    .vertical-menu .el-menu-item{
      border-bottom: 1px solid white;
      text-align: center;
      margin: 0 8px;
      padding-left: 2px !important;
      padding-right: 2px;
      padding-top: 24px;
    }
    .vertical-menu .el-menu {
      border-right: none;
    }
    .vertical-menu .el-menu-item, .el-submenu__title{
      height: 36px;
      line-height: 0;

    }

    .mobile-news-list{
      margin: 4px 20px;
      margin-top: 16px;
    }
    .content-jianjie{
      margin-top: -18px;
    }
    .content-jianjie .content-info-contain{
      /*background-image: url("../../static/images/jieshao_left_bg.png");*/
      background-repeat: no-repeat;
      background-position: left bottom;
      background-size:  80% auto;
    }
    .middle-content .content-info{
      width: 90%;
    }
    .middle-content .content-info p{
      /*padding:  8px;*/
    }
    .content-zanzhushang .content-title{
      height: 80px;
    }
    .content-zanzhushang .content-title p{
      padding-top: 26px;
    }
    .content-zanzhushang .content-info-contain{
      /*background-image: url("../../static/images/zanzhushang_bg_right_bottom.png");*/
      background-position: right bottom;
      background-repeat: no-repeat;
      background-size: 60% auto;
      padding-bottom: 2%;
    }
    .content-contactus{
      /*background-image: url("../../static/images/jieshao_left_bg.png");*/
      background-repeat: no-repeat;
      background-position: left bottom;
      background-size: 70% auto;
      margin-top: 0px;
      border-bottom: 2px solid #aaaaaa;
    }

    .footer-contain p{
      padding: 10px 0;
      padding-bottom: 40px;
    }
    .middle-content .content-info{
      font-size: 16px;
    }
    .top-right{
      height: 370px;
    }
    .top-right .right-content{
    text-align: left;
    padding: 4px 8px;
    margin-top: 4px;
    height: 320px;
    overflow-y: auto;
  }
    .valse-past .last-page ul{
      margin-left: -5px;
    }
    .zhubanfang-logo img{
      height: 60px;
      margin: 0 16px;
    }

  }
  @media screen and (max-width: 400px){
    .top-left .left-title p{
      font-size: 24px;
      font-weight: bolder;
    }
    .left_content table{
      width: 350px;
      margin: 0 auto;
      font-size: 16px;
      white-space: pre-wrap;
      word-wrap:break-word;
    }
    .left_content table .content-td{
      width: 260px;
    }

    .top-info{
      font-size: 16px;
    }
    .zhubanfang-logo img{
      height: 50px;
      margin: 0 16px;
    }
  }

  .news-time{
    margin-right: 4px;
  }


</style>



// WEBPACK FOOTER //
// src/components/Home.vue